import React from 'react';

const LinkComponent = ({ value, children }) => {
  const { href = '', blank = false } = value;

  return (
    <a href={href} target={blank ? '_blank' : ''} rel="noreferrer">
      {children}
    </a>
  );
};

export default LinkComponent;
